import serverCall from "../../serverCall";

const create3DWallpaper = async (data) => {
    const response = await serverCall.post(
        `/images/admin/3D`, data
    );
    return response;
};

const createMulti3DWallpaper = async (data) => {
    const response = await serverCall.post(
        `/images/admin/multi-3D`, data
    );
    return response;
};

const wallpaper3DService = {
    create3DWallpaper,
    createMulti3DWallpaper
};

export default wallpaper3DService;
